import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const DropdownButton = styled(Button)`
    justify-content: flex-start;

    & div:last-child {
        margin-left: auto;
    }
`;
